<span [class]="buttonClasses">
  {{ count }}
</span>
